var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import style from "./style.module.scss";
export default function RadioButton(props) {
    const { id } = props, inputProps = __rest(props, ["id"]);
    return (_jsxs("div", { className: style["radio-button"], children: [_jsx("input", Object.assign({ type: "radio", className: "visually-hidden" }, inputProps, { id: id })), _jsx("label", { className: style["radio-button__display"], htmlFor: id })] }));
}
